import { Box } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'
import { UnitType } from '../../hooks/use-unit-type-parameters'
import { CarrierType } from './CarrierTypeIcon'
import { ContainerJourneyCardBody } from './ContainerJourneyCardBody'
import { ContainerJourneyCardHeader } from './ContainerJourneyCardHeader'

export type ContainerData = {
  id: number
  number?: string | null
  isoCode?: string | null
  operator?: string | null
  length?: number | null
  height: string
  type: string
  isOnTerminal: boolean
  isEmpty: boolean
  damages: { status: 'Active' | 'Resolved' }[]
  unitType?: UnitType
  maxGross?: number | null
  tare?: number | null
  plateNumber?: string | null
}

export type OrderData = {
  id: number
  customerName?: string | null
  carrierVisit?: CarrierVisitData
  carrierVisitType?: CarrierType
  railcarName?: string | null
  isEmpty?: boolean
  imoClasses?: string[] | null
  isDangerous?: boolean
  grossWeight?: number | null
  vgm?: number | null
  referenceNumber?: string | null
}

export type CarrierVisitData = {
  identifier?: string | null
  eta?: string | null
  etd?: string | null
  ata?: string | null
  atd?: string | null
}

export type ContainerJourneyCardProps = {
  container: ContainerData
  inbound?: OrderData
  outbound?: OrderData
  isDamaged?: boolean
  primaryActionLabel?: string
  secondaryActionLabel?: string
  onPrimaryAction?: () => void
  onSecondaryAction?: () => void
}

export const ContainerJourneyCard: FC<ContainerJourneyCardProps> = props => {
  const theme = useMinimalsTheme()

  return (
    <>
      <Box
        sx={{
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: theme.customRadius.medium,
        }}
      >
        <Box>
          <ContainerJourneyCardHeader {...props} />
        </Box>

        <Box
          sx={{
            bgcolor: theme.palette.grey[100],
            borderTop: `1px solid ${theme.palette.grey[300]}`,
          }}
        >
          <ContainerJourneyCardBody {...props} />
        </Box>
      </Box>
    </>
  )
}
